import { useEffect } from "react"
import { useColourScheme, viewportQueries } from "../design-system/index.ts"
import { themeColourMetasOf } from "./theme-colours.ts"

/*
 * The browser's chrome in the scheme the Member chose. `index.html`'s `theme-color` metas follow
 * the device's setting; a Member who picked Light or Dark in the app gets metas of their own ahead
 * of those, since a browser takes the first that matches: the panel on the compact layout, where
 * the chrome meets the page header, and the canvas on the desk. On System they are removed again.
 */
export function ThemeColour() {
  const { scheme } = useColourScheme()
  useEffect(() => {
    if (scheme === "system") return
    const first = document.head.querySelector('meta[name="theme-color"]')
    const metas = themeColourMetasOf(__THEME_COLOURS__, viewportQueries.compact, scheme).map(
      ({ media, content }) => {
        const meta = document.createElement("meta")
        meta.name = "theme-color"
        if (media) meta.media = media
        meta.content = content
        document.head.insertBefore(meta, first)
        return meta
      },
    )
    return () => metas.forEach((meta) => meta.remove())
  }, [scheme])
  return null
}
